import { types, onSnapshot, getParent, getSnapshot } from "mobx-state-tree";
import shortid from 'shortid';
import Activity from "./Activity";
// import { employeeStore } from './RootStore';
// import localforage from 'localforage';

// const store = localforage.createInstance({
//   name: 'employees'
// })

export default types.model({
  id: types.identifier(types.string),
  name: '',
  currentActivity: types.maybe(types.reference(types.late(() => Activity)))
}).preProcessSnapshot(snapshot => {
  const copy = Object.assign(snapshot)
  if (!copy.id) copy.id = shortid.generate()
  // if (!copy.id) copy.id = shortid.generate()
  return copy
}).actions(self => ({
  afterAttach() {
    onSnapshot(self, snapshot => self.save())
  },
  save() {
    getParent(self, 2).saveItem(self)
  },
  setName(string) {
    self.name = string
  },
  startWork(workOrder) {
    if (self.currentActivity) {
      self.currentActivity.finish()
    }
    const rootStore = getParent(self, 2)
    const activity = Activity.create({
      employee: self,
      workOrder: workOrder,
      startedAt: new Date()
    })
    rootStore.setCollectionItemFromSnapshot('activities', getSnapshot(activity))
    self.currentActivity = activity
  },
  finishWork() {
    if (self.currentActivity) {
      self.currentActivity.finish()
      self.currentActivity = null
    }
  }
})).views(self => ({
  get isValid() {
    return self.name.length > 0
  },
  isWorking() {
    return self.currentActivity ? true : false
  }
}))


// WEBPACK FOOTER //
// ./src/models/Employee.js